import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import {
  AutomationDate,
  automationDateRules,
  AutomationDateRuleTypes,
  AutomationEventTypes,
  AutomationTypes,
  getAutomationtDateRuleByType,
} from '@tokeet-frontend/automations'
import { integer } from '@tokeet-frontend/tv3-platform'

export function createAutomationDateForm(
  fb: FormBuilder,
  date?: AutomationDate,
  options = { baseRequired: true, daysRequired: true, hoursRequired: true }
) {
  return fb.group({
    base: [date?.base, options.baseRequired ? [Validators.required] : []],
    days: [
      date?.days,
      options.daysRequired ? [Validators.required, Validators.min(0), integer()] : [Validators.min(0), integer()],
    ],
    hours: [
      date?.hours,
      options.hoursRequired ? [Validators.required, Validators.min(0), integer()] : [Validators.min(0), integer()],
    ],
  })
}

@Component({
  selector: 'app-automation-date-form',
  templateUrl: './automation-date-form.component.html',
  styleUrls: ['./automation-date-form.component.scss'],
})
export class AutomationDateFormComponent implements OnInit {
  @Input() type: AutomationTypes
  @Input() form: FormGroup
  @Input() label: string
  @Input() showHours = true
  @Input() set event(e: AutomationEventTypes) {
    if (e === AutomationEventTypes.BookingCanceled) {
      this.rules = automationDateRules.filter((t) => t.type !== AutomationDateRuleTypes.AfterBookingConfirmed)
    } else {
      this.rules = automationDateRules.filter((t) => t.type !== AutomationDateRuleTypes.AfterBookingCanceled)
    }
  }

  rules: typeof automationDateRules = []

  constructor() {}

  ngOnInit(): void {
    this.rules = getAutomationtDateRuleByType(this.type)
  }
}
